export default {
  pageTitle: '管理代金券批次',
  region: '国别',
  BD: 'BD',
  stateFiltering: '状态过滤',
  radio1: '所有',
  radio2: '待审核',
  radio3: '已审核',
  radio4: '已取消',
  radio5: '可用的',
  radio6: '已关闭',
  timeFiltering: '时间过滤',
  createCouponBatch: '创建优惠券批次',
  //  Are you sure you want to {{ this.confirmKeyword.toLowerCase() }} it?
  main1: '您确认要',
  main2: '它(们)吗',
  columns1: 'ID(批次)',
  columns2: '模版ID,名称',
  columns3: '模版名',
  columns4: '批次类型',
  businessType: '业务类型',
  businessTypeGeneral: '普通券',
  businessTypeCps: 'CPS券',
  columns5: '创建人',
  columns6: '创建时间',
  columns7: '条件',
  columns8: '面额',
  columns9: '限制',
  columns10: '审核时间',
  columns11: '审核人',
  columns12: '发行数',
  columns13: '已被领取数',
  columns14: '开始时间',
  columns15: '截止时间',
  columns16: '领取后有效期',
  columns17: '限制类型',
  columns18: '限制值',
  columns19: '所有者类型',
  columns20: '状态',
  columns21: '操作人',
  columns22: '操作',
  // -----------
  genType1: '大厅',
  genType2: '定向',
  genType5: '隐藏券',
  hide: '隐藏',
  multiValues: '多值',
  ownerType1: '平台',
  ownerType2: '店铺',
  status1: '待审核',
  status2: '已审核',
  status3: '已取消',
  status4: '已下架',
  buttonValue1: '取消',
  buttonValue2: '下架',
  confirmKeyword1: '取消',
  confirmKeyword2: '下架',
  forStore: '应对店铺'
}
